// src/hooks/useFCM.js
// Hook để xin quyền push notification và lưu FCM token

import { useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { doc, updateDoc } from "firebase/firestore";
import { db, getMessagingInstance } from "../lib/firebase";
import { useAuth } from "../contexts/AuthContext";
import toast from "react-hot-toast";

// TODO: Lấy VAPID key từ Firebase Console
// Project settings → Cloud Messaging → Web Push certificates → Generate key pair
const VAPID_KEY = "BBXrsVgWxRveDLkxa-IPvJMpjV1N-t8x9-wyPYgPjUK7EFABciPdpwDKKfm65X4B7lasmdnXUgsmA1ptE0Gm9uU";

export function useFCM() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    setupFCM();
  }, [user]);

  const setupFCM = async () => {
    try {
      const messagingInstance = await getMessagingInstance();
      if (!messagingInstance) return; // browser không hỗ trợ

      // Xin quyền thông báo
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.log("Người dùng từ chối push notification.");
        return;
      }

      // Lấy FCM token
      const token = await getToken(messagingInstance, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        ),
      });

      if (token) {
        // Lưu token vào Firestore để Cloud Functions dùng khi gửi push
        await updateDoc(doc(db, "users", user.uid), { fcmToken: token });
        console.log("FCM token đã lưu.");
      }

      // Xử lý notification khi app đang mở (foreground)
      onMessage(messagingInstance, (payload) => {
        const { title, body } = payload.notification;
        toast(
          (t) => (
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <strong style={{ fontSize: 14 }}>{title}</strong>
              <span style={{ fontSize: 13, opacity: 0.8 }}>{body}</span>
            </div>
          ),
          {
            duration: 5000,
            icon: "🔔",
          }
        );
      });
    } catch (err) {
      console.error("Lỗi FCM:", err);
    }
  };
}
